import { useEffect, useState, useRef, useMemo, useCallback } from 'react'
import { Button, Typography, Tabs, Tab, CircularProgress, Chip, Container } from '@mui/material'
import useTickers from '../../../hooks/useTickers'
import TickerDropdown from '../../../components/ui/tickerDropdown/TickerDropdown'
import Select from '../../../components/ui/Select'
// import pdfIcon from '../images/pdf.svg'
import pdfIcon from '../images/pdf1.svg'
import useExportReport from '../hooks/useExportReport'
import { useReportPageContext } from '../context/useReportPageContext'
import styles from './ReportPage.module.scss'

const ReportPageHeader = () => {
    const { templates, selectedTickers, selectedReports, handleUpdateTickers, handleUpdateReportTemplate, uuid, tab, handleChangeTab } = useReportPageContext()
    const { handleExportToPDF, isLoading } = useExportReport(uuid)
    const { tickers } = useTickers()

    const [ isStickyReportPageHeader, setIsStickyReportPageHeader ] = useState(false)
    const ref = useRef()

    const scrollHandler = () => {
        ref.current?.getBoundingClientRect().top < 0 ? setIsStickyReportPageHeader(true) : setIsStickyReportPageHeader(false)
    }

    const tickersValue = useMemo(() => selectedTickers?.map(({value}) => value),[selectedTickers])
    
    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler)
    }, [])

    const renderTags = (value, getTagProps) => (
        value.map((option, index) => (
          <Chip
            label={<p className={styles['chip-limited-width']}>{option?.value}</p>}
            {...getTagProps({ index })}
          />
        ))
    )

    const handleUpdateTab = useCallback((e, value) => handleChangeTab({name: e.currentTarget.innerText, value}), [handleChangeTab])
    const tabsComponent = useMemo(() => (
        <Tabs 
            value={tickersValue?.includes(tab?.value) ? tab.value : false} 
            onChange={handleUpdateTab} 
            // indicatorColor="secondary" 
            // textColor="undefine"
            
            textColor='inherit'
            TabIndicatorProps={{
                style: {
                  backgroundColor: "#dccb03"
                }
              }}
            
            >{ selectedTickers?.map(({value: ticker, name}) => (
                <Tab
                    component="a"
                    href={`#${ticker}`}
                    classes={{root: styles['tab']}}
                    label={name}
                    value={ticker}
                    key={ticker}
                />))}
        </Tabs>
    ),[tab, selectedTickers, handleUpdateTab, tickersValue])

    const exportBtn = useMemo(() => (
        <Button 
            classes={{root: styles['export-btn']}}
            onClick={handleExportToPDF}
            disabled={isLoading || !selectedTickers?.length}
            variant="contained" 
            color='primary' 
            size='large'>
                {isLoading ? <CircularProgress size={20}/> : <img src={pdfIcon} alt='pdf icon'/>} Export to PDF
        </Button>
    ),[handleExportToPDF, isLoading, selectedTickers])

    const title = useMemo(() => <Typography variant="h1" className={styles['title']}>Fundamental Edge Studio</Typography> ,[])

    return (
        <div className={styles['header']}>
            <Container maxWidth="xl" component="section">
                {title}
                <div className={styles['header-select']} ref={ref}>
                    <div>
                        <TickerDropdown 
                            options={tickers} 
                            value={tickersValue} 
                            handleChange={handleUpdateTickers} 
                            shouldShowChips
                            multiple
                            disableCloseOnSelect
                            limit={4}
                            loading={!selectedTickers}
                            renderTags={renderTags}
                        />
                        <Select 
                            elevation={1}
                            options={templates ?? []} 
                            label="Your Template Label Here" 
                            setSelectedValue={handleUpdateReportTemplate}
                            selectedValue={templates ? selectedReports: '' }
                        />
                    </div>
                    {exportBtn}
                </div>
                <div className={styles['tabs']}>
                    {tabsComponent}
                </div>
            </Container>
            <div className={`${styles['sticky-report-page-header']} ${isStickyReportPageHeader ? styles['show'] : styles['hide']}`}>
                <Container maxWidth="xl" component="section">
                    <div>
                        <div>
                            {title}
                            {tabsComponent}
                        </div>
                        {exportBtn}
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default ReportPageHeader